<template>
  <div
    v-if="show"
    class="su-mask"
    @click.self="changeShow"
    :style="{backgroundColor:`rgba(0, 0, 0, ${opacity})`}"
  >
    <slot></slot>
  </div>
</template>
<script>
import { lockScroll } from '@/static/js/zjs.js';
const bodyScroll = lockScroll();
export default {
  model: {
    prop: 'show',
    event: 'on-visible'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    click: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Number,
      default: 0.8
    }
  },
  data() {
    return {
      hasClick: false
    };
  },
  watch: {
    show: {
      handler: function(newval, oldval) {
        if (newval) {
          bodyScroll.lock();
        } else {
          bodyScroll.unLock();
        }
      }
    }
  },
  computed: {},
  methods: {
    changeShow() {
      this.$emit('on-click');
      if (this.click) {
        this.$emit('update:show', !this.show);
        this.$emit('on-visible', !this.show);
      }
    }
  },
  destroyed() {
    const body = document.querySelector('body');
    body.removeChild(this.$el);
  },
  mounted() {
    // 危险的操作，容易导致相邻组件节点v-for渲染失败
    if (this.show) {
      bodyScroll.lock();
    }
    this.$nextTick(() => {
      const body = document.querySelector('body');
      if (body.append) {
        body.append(this.$el);
      } else {
        body.appendChild(this.$el);
      }
    });
  }
};
</script>
<style lang="scss">
.su-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
</style>